import { UserInterfaceDto } from "@intelligems/ig-types/dtos/user-interfaces";
import { WidgetDto } from "@intelligems/ig-types/dtos/widgets";

export function updateUserInterfaceWidgets(
  userInterfaces: UserInterfaceDto[] | undefined,
  widget: WidgetDto
) {
  if (!userInterfaces) {
    return undefined;
  }

  for (const userInterface of userInterfaces) {
    if (userInterface.widget?.id === widget.id) {
      userInterface.widget = widget;
    }
  }
}
